import { Mark, mergeAttributes } from '@tiptap/core';
import { Plugin, PluginKey, Transaction } from '@tiptap/pm/state';

export const SuggestionHighlight = Mark.create({
	name: 'suggestion-highlight',
	inclusive: false,
	excludes: '',

	addAttributes() {
		return {};
	},

	parseHTML() {
		return [{ tag: 'span[data-suggestion-highlight]' }];
	},

	renderHTML({ HTMLAttributes }) {
		return [
			'span',
			mergeAttributes(HTMLAttributes, {
				'data-suggestion-highlight': '',
				style:
					'text-decoration-line: underline; text-decoration-style: dotted; text-decoration-color: var(--chakra-colors-ai-text-underline); text-decoration-thickness: 2px; text-underline-offset: 0.18em;',
			}),
			0,
		];
	},

	addProseMirrorPlugins() {
		const markType = this.type;
		return [
			new Plugin({
				key: new PluginKey('suggestion-highlight-remover'),
				appendTransaction(transactions, _oldState, newState) {
					const docChanged = transactions.some((tr) => tr.docChanged);
					if (!docChanged) return null;

					const isInsertion = transactions.some((tr) => tr.getMeta('suggestion-highlight-insertion') === true);
					if (isInsertion) return null;

					let outTr: Transaction | null = null;

					transactions.forEach((transaction) => {
						if (!transaction.docChanged) return;
						transaction.steps.forEach((step) => {
							step.getMap().forEach((_oldStart, _oldEnd, newStart, newEnd) => {
								// Expand by 1 on each side so deletions (newStart === newEnd)
								// still catch the marked text remaining around the deletion point.
								const checkFrom = Math.max(0, newStart - 1);
								const checkTo = Math.min(newState.doc.content.size, newEnd + 1);
								newState.doc.nodesBetween(checkFrom, checkTo, (node, pos) => {
									if (!node.isText) return;
									if (node.marks.some((m) => m.type === markType)) {
										if (!outTr) outTr = newState.tr;
										outTr.removeMark(pos, pos + node.nodeSize, markType);
									}
								});
							});
						});
					});

					return outTr;
				},
			}),
		];
	},
});
